(function() {
 window.DIYInitTurnaround = function(root) {
  if (!root) return;
  if (root._cstcCleanup) root._cstcCleanup();

  var prodDays    = JSON.parse(root.dataset.productionDays || '[]');
  var blkDates    = JSON.parse(root.dataset.blackoutDates  || '[]');
  var calendar = window.DIYCalendarCore.create((root.dataset.productionClosures || '') + '\n' + blkDates.join('\n'));
  var printCut    = root.dataset.printCutoff  || '17:00';
  var shipCut     = root.dataset.shipCutoff   || '13:00';
  var turnDays    = parseInt(root.dataset.turnaround, 10) || 0;
  var cutDisp     = root.dataset.cutoffDisp || '5 PM ET';

  /* Dual cutoff slide rotation */
  var dualSlides = root.querySelectorAll('[data-slide]');
  var dualIdx = 0;
  if (dualSlides.length > 1) {
    var dualTimer = setInterval(function() {
      dualSlides[dualIdx].classList.remove('cstc__dual-slide--active');
      dualSlides[dualIdx].classList.add('cstc__dual-slide--exiting');
      dualIdx = (dualIdx + 1) % dualSlides.length;
      dualSlides[dualIdx].classList.remove('cstc__dual-slide--exiting');
      dualSlides[dualIdx].classList.add('cstc__dual-slide--active');
      setTimeout(function() {
        for (var i = 0; i < dualSlides.length; i++) {
          if (i !== dualIdx) dualSlides[i].classList.remove('cstc__dual-slide--exiting');
        }
      }, 500);
    }, 4000);
  }

  /* DOM */
  var elH    = root.querySelector('[data-cstc-h]');
  var elM    = root.querySelector('[data-cstc-m]');
  var elS    = root.querySelector('[data-cstc-s]');
  var elInl  = root.querySelector('[data-cstc-inline]');
  var elLbl  = root.querySelector('[data-cstc-label]');
  var elTLv  = root.querySelector('[data-timer-live]');
  var elTNx  = root.querySelector('[data-timer-next]');
  var elDay  = root.querySelector('[data-next-day]');
  var elDt   = root.querySelector('[data-next-date]');
  var msgA   = root.querySelector('[data-msg-1]');
  var msgB   = root.querySelector('[data-msg-2]');

  /* Editable text (output from Liquid) */
  var LIVE1  = root.dataset.liveMsg1;
  var LIVE2  = root.dataset.liveMsg2;
  var NEXT1  = root.dataset.nextMsg1;
  var NEXT2  = root.dataset.nextMsg2;

  /* ── America/New_York time ── */
  function getNY() {
    return window.DIYCalendarCore.wallNow('America/New_York');
  }

  function dayName(d) {
    return ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][d.getDay()];
  }

  /* Ordinal: 1→"1st" 2→"2nd" 3→"3rd" 21→"21st" */
  function ord(n) {
    var s = ['th','st','nd','rd'], v = n % 100;
    return n + (s[(v-20)%10] || s[v] || s[0]);
  }

  function pad(n) { return String(n).padStart(2,'0'); }

  function dkey(d) {
    return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());
  }

  function isBlkout(d) { return calendar.isClosed(dkey(d)); }
  function isProd(d)   { return prodDays.indexOf(dayName(d)) !== -1 && !isBlkout(d); }

  function atTime(ts, ref) {
    var p = ts.split(':').map(Number), d = new Date(ref);
    d.setHours(p[0], p[1], 0, 0);
    return d;
  }

  function nextProd(from) {
    if (!prodDays.length || prodDays.every(function(day){return !day;})) return null;
    for (var i=1; i<=3660; i++) {
      var d = new Date(from);
      d.setDate(from.getDate()+i);
      if (isProd(d)) return d;
    }
    return null;
  }

  function printByDate(now) {
    if (turnDays === 0) return null;
    var cut   = atTime(printCut, now);
    var start = (isProd(now) && now < cut) ? now : nextProd(now);
    if (!start) return null;
    var count = 0;
    for (var i=0; i<=3660; i++) {
      var c = new Date(start); c.setDate(start.getDate()+i);
      if (isProd(c) && ++count >= turnDays) return c;
    }
    return null;
  }

  /* Dual cutoff labels */
  var elShipLbl  = root.querySelector('[data-ship-label]');
  var elLocalLbl = root.querySelector('[data-local-label]');

  function fmtCutoff(ts) {
    var p = ts.split(':').map(Number), h = p[0], m = p[1] || 0;
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return m === 0 ? h12 + ' ' + ap + ' ET' : h12 + ':' + pad(m) + ' ' + ap + ' ET';
  }

  var SHIP_LABEL  = root.dataset.shipLabelText;
  var LOCAL_LABEL = root.dataset.localLabelText;
  function safeText(value) { var span = document.createElement('span'); span.textContent = value || ''; return span.innerHTML; }
  SHIP_LABEL = safeText(SHIP_LABEL);
  LOCAL_LABEL = safeText(LOCAL_LABEL);

  function updateDualLabels(now) {
    var sAt = atTime(shipCut, now);
    var pAt = atTime(printCut, now);
    var prod = isProd(now);

    if (elShipLbl) {
      if (prod && now < sAt) {
        elShipLbl.innerHTML = SHIP_LABEL + ' \u2014 Order by <strong>' + fmtCutoff(shipCut) + '</strong>';
      } else {
        elShipLbl.innerHTML = SHIP_LABEL + ' \u2014 Next Business Day';
      }
    }
    if (elLocalLbl) {
      if (prod && now < pAt) {
        elLocalLbl.innerHTML = LOCAL_LABEL + ' \u2014 Order by <strong>' + fmtCutoff(printCut) + '</strong>';
      } else {
        elLocalLbl.innerHTML = LOCAL_LABEL + ' \u2014 Next Business Day';
      }
    }
  }

  /* ── Update digits ── */
  function setD(el, v) {
    if (!el) return;
    var s = pad(v);
    if (el.textContent !== s) el.textContent = s;
  }

  /* ── Rotate messages ── */
  var slot = 'a', swapT;

  function setMsgs(m1, m2) {
    if (msgA) msgA.textContent = m1;
    if (msgB) msgB.textContent = m2;
  }

  function swap() {
    clearInterval(swapT);
    if (!msgA || !msgB) return;
    msgA.className = 'cstc__msg cstc__msg-a';
    msgB.className = 'cstc__msg cstc__msg-b';
    slot = 'a';
    swapT = setInterval(function() {
      if (slot === 'a') { msgA.classList.add('out');  msgB.classList.add('in');  slot = 'b'; }
      else              { msgA.classList.remove('out'); msgB.classList.remove('in'); slot = 'a'; }
    }, 3500);
  }

  /* ── Show state ── */
  function showLive() {
    root.dataset.state = 'live';
    if (elTLv) elTLv.style.display = '';
    if (elTNx) elTNx.style.display = 'none';
  }

  function showNext() {
    root.dataset.state = 'next';
    if (elTLv) elTLv.style.display = 'none';
    if (elTNx) elTNx.style.display = '';
  }

  /* ── Main loop ── */
  var lastState = '';

  function tick() {
    if (!root.isConnected) { if (root._cstcCleanup) root._cstcCleanup(); return; }
    var now     = getNY();
    var prod    = isProd(now);
    var pAt     = atTime(printCut, now);
    var sAt     = atTime(shipCut,  now);
    var bfP     = now < pAt;
    var bfS     = now < sAt;
    var state, rem;

    if (turnDays === 0) {
      /* Same-day logic */
      if (prod && bfP) {
        state = 'live';
        rem   = Math.floor((pAt - now) / 1000);
        var h = Math.floor(rem/3600), m = Math.floor((rem%3600)/60), s = rem%60;
        setD(elH,h); setD(elM,m); setD(elS,s);
        if (elInl) elInl.textContent = h+'h '+pad(m)+'m '+pad(s)+'s';
        if (elLbl) elLbl.innerHTML = 'Order by <strong>'+cutDisp+'</strong> to qualify';
        var shipNext = nextProd(now);
        var tomorrowKey = window.DIYCalendarCore.shift(dkey(now), 1);
        setMsgs(LIVE1, bfS ? LIVE2 : (shipNext && dkey(shipNext) === tomorrowKey ? 'Ships Tomorrow' : NEXT1));
      } else {
        state = 'next';
        var nx = nextProd(now);
        var dn = nx ? dayName(nx) : 'TBD';
        var dd = nx ? ord(nx.getDate()) : '—';
        if (elDay) elDay.textContent = dn;
        if (elDt)  elDt.textContent  = dd;
        if (elInl) elInl.textContent = dn+', '+dd;
        if (elLbl) elLbl.innerHTML   = 'Your order prints:';
        setMsgs(NEXT1, NEXT2);
      }
    } else {
      /* Multi-day logic */
      var bd  = printByDate(now);
      var bdn = bd ? dayName(bd) : 'TBD';
      var bdd = bd ? ord(bd.getDate()) : '—';

      if (prod && bfP) {
        state = 'live';
        rem   = Math.floor((pAt - now) / 1000);
        var h2= Math.floor(rem/3600), m2=Math.floor((rem%3600)/60), s2=rem%60;
        setD(elH,h2); setD(elM,m2); setD(elS,s2);
        if (elInl) elInl.textContent = h2+'h '+pad(m2)+'m '+pad(s2)+'s';
        if (elLbl) elLbl.innerHTML = 'Order by <strong>'+cutDisp+'</strong> to qualify';
        setMsgs('Printed by '+bdn+', '+bdd, 'Order by '+cutDisp);
      } else {
        state = 'next';
        if (elDay) elDay.textContent = bdn;
        if (elDt)  elDt.textContent  = bdd;
        if (elInl) elInl.textContent = bdn+', '+bdd;
        if (elLbl) elLbl.innerHTML   = 'Your order prints:';
        setMsgs(NEXT1, NEXT2);
      }
    }

    updateDualLabels(now);

    if (state !== lastState) {
      lastState = state;
      if (state === 'live') showLive(); else showNext();
      swap();
    }
  }

  showLive(); /* initial — prevents layout flash before first tick */
  tick();
  var tickTimer = setInterval(tick, 1000);
  root._cstcCleanup = function(){ clearInterval(tickTimer); clearInterval(dualTimer); clearInterval(swapT); };
 };
 document.querySelectorAll('.cstc').forEach(window.DIYInitTurnaround);
})();
